'use client';

import { useTranslations } from 'next-intl';
import { useState, useEffect, useRef } from 'react';
import { CustomImage as Image } from 'components/shared';
import {
  RingProColors,
  getRingProColorNameImages,
} from 'content/products/ring-pro';
import { ringProKeyT } from 'content/products/ring-pro/ringProKeyT';
import styles from './RealLifeImagesModalContent.module.css';

// TODO: RING PRO IMPROVEMENTS - Add Ring Pro lifestyle image paths for each color
// Update the directory mapping and image count per color once assets are uploaded
const RING_PRO_LIFESTYLE_BASE = 'web_v2/ring-pro-lifestyle-images';

const RING_PRO_COLOR_DIR: Record<RingProColors, string> = {
  [RingProColors.GOLD]: 'gold',
  [RingProColors.SILVER]: 'silver',
  [RingProColors.BLACK]: 'black',
  [RingProColors.TITANIUM]: 'titanium',
};

const IMAGE_COUNT = 5;

const RealLifeImagesModalContentBase = ({
  className,
  selectedColor,
}: {
  className?: string;
  selectedColor: RingProColors;
}) => {
  const t = useTranslations('ring');
  const tCommon = useTranslations('common');
  const tRingPro = useTranslations('ring-pro');
  const RingProColorNameImages = getRingProColorNameImages(
    ringProKeyT(t, tRingPro),
  );
  const [activeTab, setActiveTab] = useState<RingProColors>(
    selectedColor ?? RingProColors.GOLD,
  );
  const btnRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const idx = Object.values(RingProColors).indexOf(activeTab);
    if (btnRefs.current[idx]) {
      btnRefs.current[idx]?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeTab]);

  const dir = RING_PRO_COLOR_DIR[activeTab];

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <h2>{tCommon('realLifeImagesModalContent.heading.realLifeImages')}</h2>
      <div className="btn-container-wrapper u-hide-scrollbar">
        <div className="btn-container">
          {Object.values(RingProColors).map((element, index) => {
            return (
              <button
                key={index}
                ref={(el) => {
                  btnRefs.current[index] = el;
                }}
                onClick={() => setActiveTab(element)}
                className={activeTab === element ? 'active' : undefined}
                type="button"
                aria-label={RingProColorNameImages[element].name as string}
                aria-pressed={activeTab === element}
              >
                {RingProColorNameImages[element].name}
              </button>
            );
          })}
        </div>
      </div>
      <div className="img-container">
        {Array.from({ length: IMAGE_COUNT }, (_, i) => (
          <Image
            key={i}
            src={`${RING_PRO_LIFESTYLE_BASE}/${dir}/${i + 1}.png/w_1080`}
            alt={RingProColorNameImages[activeTab].name as string}
            width="400"
            height="400"
            className={i === 2 ? 'full' : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export const RingProRealLifeImagesModalContent = RealLifeImagesModalContentBase;
